/**
 * ASSETS BASE PATH
 */
export const ASSETS_PATH = process.env.REACT_APP_API_ASSETS_PATH;

/**
 * BASE PATH for APIS
 */
export const BASE_URL = process.env.REACT_APP_API_BASE_URL;

/**
 * S3 BUCKET URL
 */
export const BUCKET_URL = 
  "https://wookai-service-uploads.s3.us-east-2.amazonaws.com";

/**
 * Auth
 */
export const AUTH_ENDPOINT = `${BASE_URL}/auth`;

/**
 * Accounts
 */
export const ACCOUNTS_ENDPOINT = `${BASE_URL}/accounts`;

/**
 * Users
 */
export const USERS_ENDPOINT = `${BASE_URL}/users`;

/**
 * Admins
 */
export const ADMINS_ENDPOINT = `${BASE_URL}/admins`;

/**
 * Clients
 */
export const CLIENTS_ENDPOINT = `${BASE_URL}/clients`;

/**
 * Supplier Reps
 */
export const SUPPLIER_REPS_ENDPOINT = `${BASE_URL}/supplierReps`;

/**
 * Client Reps
 */
export const REP_CLIENTS_ENDPOINT = `${BASE_URL}/repClients`;

/**
 * Units
 */
export const UNITS_ENDPOINT = `${BASE_URL}/units`;

/**
 * Units List
 */
export const CONVERSIONS_ENDPOINT = `${BASE_URL}/conversions`;

/**
 * Videos
 */
export const VIDEOS_ENDPOINT = `${BASE_URL}/videos`;

/**
 * Settings
 */
export const SETTINGS_ENDPOINT = `${BASE_URL}/settings`;

/**
 * Mass Emails
 */
export const MASS_EMAILS_ENDPOINT = `${BASE_URL}/massEmails`;

/**
 * Canned Emails
 */
export const CANNED_EMAILS_ENDPOINT = `${BASE_URL}/cannedEmails`;

/**
 * Cms
 */
export const CMS_ENDPOINT = `${BASE_URL}/cms`;

/**
 * Cms
 */
export const ADS_ENDPOINT = `${BASE_URL}/adCodes`;

/**
 * Email Contents
 */
export const EMAIL_CONTENTS_ENDPOINT = `${BASE_URL}/emailContents`;

/**
 * business Profiles
 */
export const BUSINESS_PROFILES_ENDPOINT = `${BASE_URL}/businessProfiles`;

/**
 * business Locations
 */
export const BUSINESS_LOCATIONS_ENDPOINT = `${BASE_URL}/businessLocations`;

/**
 * Profiles
 */
export const DEFAULT_PROFILES_ENDPOINT = `${BASE_URL}/defaultProfiles`;

/**
 * Vendors
 */
export const VENDORS_ENDPOINT = `${BASE_URL}/vendors`;

/**
 * Countries
 */
export const COUNTRIES_ENDPOINT = `${BASE_URL}/countries`;

/**
 * States
 */
export const STATES_ENDPOINT = `${BASE_URL}/states`;

/**
 * TimeZones
 */
export const TIMEZONES_ENDPOINT = `${BASE_URL}/timeZones`;

/**
 * ItemLocations
 */
export const ITEM_LOCATIONS_ENDPOINT = `${BASE_URL}/itemLocations`;

/**
 * Categories
 */
export const CATEGORIES_ENDPOINT = `${BASE_URL}/categories`;

/**
 * SubCategories
 */
export const SUB_CATEGORIES_ENDPOINT = `${BASE_URL}/subCategories`;

/**
 * Products
 */
export const PRODUCTS_ENDPOINT = `${BASE_URL}/products`;

/**
 * Vendor Items
 */
export const VENDOR_ITEMS_ENDPOINT = `${BASE_URL}/vendorItems`;

/**
 * Product Item relations
 */
export const PRODUCT_ITEM_RELATIONS_ENDPOINT = `${BASE_URL}/productItemRelations`;

/**
 * Ignore Comments
 */
export const IGNORE_COMMENTS_ENDPOINT = `${BASE_URL}/ignoreComments`;

/**
 * Wookai Vendors
 */
export const WOOKAI_VENDORS_ENDPOINT = `${BASE_URL}/wookaiVendors`;

/**
 * Orders
 */
export const ORDERS_ENDPOINT = `${BASE_URL}/orders`;

/**
 * Emergency items
 */
export const EMERGENCY_ITEMS_ENDPOINT = `${BASE_URL}/emergencyItems`;

/**
 * ENQUIRIES
 */
export const ENQUIRIES_ENDPOINT = `${BASE_URL}/enquiries`;

/**
 * REPORTS
 */
export const REPORTS_ENDPOINT = `${BASE_URL}/reports`;

/**
 * RECEIPES
 */
export const RECEIPES_ENDPOINT = `${BASE_URL}/receipes`;

/**
 * PREP PLANS
 */
export const PREP_PLANS_ENDPOINT = `${BASE_URL}/prepPlans`;

/**
 * PREP PLAN REPORTS
 */
export const PREP_PLAN_REPORTS_ENDPOINT = `${BASE_URL}/prepPlanReports`;

/**
 * Ideal Product costs
 */
export const IDEAL_PRODUCT_COSTS_ENDPOINT = `${BASE_URL}/idealProductCosts`;

/**
 * Product categories
 */
export const PRODUCT_CATEGORIES_ENDPOINT = `${BASE_URL}/productCategories`;

/**
 * Product Sub categories
 */
export const PRODUCT_SUB_CATEGORIES_ENDPOINT = `${BASE_URL}/productSubCategories`;

/**
 * Subscriptions end point
 */
export const SUBSCRIPTIONS_ENDPOINT = `${BASE_URL}/subscriptions`;

/**
 * Inventory Costs end point
 */
export const INVENTORY_COSTS_ENDPOINT = `${BASE_URL}/inventoryCosts`;